import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Divider,
  Box,
  Grid,
} from "@mui/material";
import { formatDisplayDate } from "../utils/date";

const Loan360Modal = ({ open, onClose, loan }) => {
  if (!loan) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Loan 360° View - Loan #{loan.id}
      </DialogTitle>

      <DialogContent>
        <Box>
          <Typography variant="h6" gutterBottom>Loan Details</Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}><strong>Applicant:</strong> {loan.firstName} {loan.lastName}</Grid>
            <Grid item xs={6}><strong>Loan Product:</strong> {loan.loanProduct}</Grid>
            <Grid item xs={6}><strong>Requested Amount:</strong> Ksh {loan.requestedAmount?.toLocaleString()}</Grid>
            <Grid item xs={6}><strong>Calculated Interest:</strong> Ksh {loan.calculatedInterest?.toLocaleString()}</Grid>
            <Grid item xs={6}><strong>Total Repayable:</strong> Ksh {loan.totalRepayableAmount?.toLocaleString()}</Grid>
            <Grid item xs={6}><strong>Status:</strong> {loan.status}</Grid>
            <Grid item xs={6}><strong>Application Date:</strong> {formatDisplayDate(loan.applicationDate)}</Grid>
            <Grid item xs={6}><strong>Disbursement Date:</strong> {formatDisplayDate(loan.disbursementDate)}</Grid>
            <Grid item xs={6}><strong>Due Date:</strong> {formatDisplayDate(loan.dueDate)}</Grid>
            <Grid item xs={6}><strong>Disbursement Phone:</strong> {loan.disbursementPhoneNumber || '-'}</Grid>
            <Grid item xs={12}><strong>Reason for Rejection:</strong> {loan.reasonForRejection || '-'}</Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box>
          <Typography variant="h6" gutterBottom>Guarantors</Typography>
          {/* You can enhance this with a GraphQL fetch for guarantors if needed */}
          {loan.guarantors?.length > 0 ? (
            <Box component="ul" sx={{ pl: 3 }}>
              {loan.guarantors.map((g) => (
                <li key={g.guarantorId}>
                  {g.firstName} {g.lastName} - Pledged: Ksh {g.amountPledged?.toLocaleString()} - Paid Back: Ksh {g.amountPaidBack?.toLocaleString()}
                </li>
              ))}
            </Box>
          ) : (
            <Typography>No guarantors assigned.</Typography>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Loan360Modal;
